<template>
    <div class="menu w1200">

        <img @click="gotoHome" src="@/assets/login/logo3.png" alt="">

        <!-- 移动端菜单开关（PC 端隐藏），位于导航栏右上角 -->
        <div class="menu-toggle"
             @click="menuOpen = !menuOpen">
            <i :class="menuOpen ? 'el-icon-close' : 'el-icon-s-fold'"></i>
            <span>菜单</span>
        </div>

        <div class="list sky"
             :class="{ open: menuOpen }">
            <span v-for="(item, index) in menu" :key="index" @click="gotoRouter(item, index)"
                :class="{ active: vuex_menuActiveIndex === index }">
                {{ item.name }}
                <span v-if="item.status === 'jsz'" class="jsz">
                    正在建设中...
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // menuActive: 0,
            // 移动端菜单展开状态（PC 端不生效）
            menuOpen: false,
            menu: [
                { name: "首页", url: '/home' },
                { name: "缩水单大厅", url: '/ssddt' },
                // { name: "缩水单冠王", url: '/ssdgw' },
                // { name: "十大缩水学霸", url: '/sdssxb' },
                { name: "缩水条件大厅", url: '/excel' },
                { name: "海选万元实战单", url: '/hxwysz' },
                { name: "缩水软件特区", url: '/suoshuiruanjian', },
                // { name: "实体投注站帮扶中心", url: '/sttzzbfzx', status: 'jsz' },
                { name: "实体投注站帮扶中心", url: '/sttzzbfzx' },
                { name: "彩运论坛", url: 'http://bbs.36886.net/' },
                { name: "帮助中心", url: '/personalCenter/help/help' },
            ],
        };
    },
    methods: {
        gotoHome() {
            this.$router.replace('/home');
            this.$vuex('vuex_menuActiveIndex', 0)
            this.menuOpen = false
        },
        gotoRouter(item, index) {
            this.$vuex('vuex_menuActiveIndex', index)
            this.menuOpen = false

            if (item.name == '彩运论坛') {
                window.open(item.url)
                return
            }
            // if (['实体投注站帮扶中心'].includes(item.name)) {
            //     this.$alert('敬请期待...', '提示', {
            //         type: 'warning',
            //         closeOnClickModal: true,
            //         confirmButtonText: '确定',
            //     });
            //     return
            // }
            this.$router.replace(item.url);
            this.menuActive = index
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/commonStyle.scss";

.menu {
    margin: 30px auto;
    display: flex;
    align-items: flex-start;
    background-color: $theme_color;
    height: 60px;
    overflow: hidden;

    >img {
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        transform: scale(1.16);
        transform-origin: right;
        cursor: pointer;
    }

    // 移动端菜单开关（PC 端隐藏，仅移动端显示）
    .menu-toggle {
        display: none;
    }

    .list {
        font-weight: bold;

        >span {
            min-width: 100px;
            padding: 0 10px;
            text-align: center;
            color: #fff;
            display: inline-block;
            cursor: pointer;
            position: relative;
            height: 60px;
            line-height: 60px;

            .jsz {
                position: absolute;
                font-size: 12px;
                left: 0;
                width: 100%;
                color: blanchedalmond;
                top: 20px;
            }

            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }

            &.active {
                // color: #FF0000;
                background-color: rgba(0, 0, 0, 0.2);
            }
        }
    }
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
    .menu {
        position: relative;
        height: 60px;
        min-height: 60px;
        // 下拉菜单需要溢出显示，不能裁剪
        overflow: visible;

        // 开关按钮：贴在导航栏右上角（滚动条下方）
        .menu-toggle {
            display: flex;
            align-items: center;
            margin-left: auto;
            height: 60px;
            padding: 0 16px;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
            user-select: none;

            i {
                font-size: 20px;
                margin-right: 6px;
            }
        }

        // 导航内容收进开关里：默认隐藏，展开时下拉铺满整屏宽度
        .list {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            z-index: 20;
            background-color: #fff;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

            &.open {
                display: block;
            }

            >span {
                display: block;
                min-width: 0;
                height: 44px;
                line-height: 44px;
                padding: 0 16px;
                text-align: left;
                color: #333;
                border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                .jsz {
                    position: static;
                    display: inline-block;
                    width: auto;
                    margin-left: 6px;
                    top: auto;
                }
            }
        }
    }
}
</style>
